import React, { useCallback } from 'react';

// import { getComponents } from './Types';
// import { isValidAnswerSetTypeForQuestion } from '../../answer-set-utils';

import ErrorMessage from 'js/components/Assessment/Editors/common/components/EditorErrors/ErrorMessage';
import { useAnswerSetContext } from './AnswerSetContext';
export function AnswerSet({
  answerSet,
  question,
  onChoiceAdd = () => {},
  onChoiceDelete = () => {},
  onChoiceUpdate = () => {},
  onChoiceMove = () => {},
  onAnswerSetChange = () => {},
  onFieldChange = () => {},
  idAttribute = 'guid',
}) {
  const { getComponents, isValidAnswerSetTypeForQuestion } =
    useAnswerSetContext();
  const { ChoiceEditor } = getComponents(question?.type);
  const isValidAnswerSet = isValidAnswerSetTypeForQuestion(
    question.type,
    answerSet?.type
  );
  const choiceCount = Object.keys(answerSet?.choices ?? {}).length;
  const hasChoices = isValidAnswerSet && choiceCount > 0;

  const handleAddChoice = useCallback(
    (choiceProps) => {
      const answerSetId = isValidAnswerSet ? answerSet[idAttribute] : null;
      onChoiceAdd(question.guid, answerSetId, choiceProps);
    },
    [isValidAnswerSet, answerSet, question, onChoiceAdd, idAttribute]
  );

  return (
    <div>
      <div className="setting-only">Choices</div>
      <div>
        <ChoiceEditor
          answerSet={answerSet}
          question={question}
          questionId={question.guid}
          questionType={question.type}
          onAddChoice={handleAddChoice}
          onDeleteChoice={onChoiceDelete}
          onChoiceUpdate={onChoiceUpdate}
          onChoiceMove={onChoiceMove}
          onAnswerSetChange={onAnswerSetChange}
          onFieldChange={onFieldChange}
          idAttribute={idAttribute}
        />
      </div>
      {!hasChoices && (
        <div className="invalid-feedback force-show">
          <ErrorMessage>At least one option is required</ErrorMessage>
        </div>
      )}
    </div>
  );
}

export default AnswerSet;
